

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {namespace} from "vuex-class";

  const authModule = namespace("authModule");

  const DEBOUNCE_TIME = 1000;

  @Component({
  })
  export default class LoginDialog extends Vue {

    @authModule.Getter('token')
    protected token!: string;

    protected showing: boolean = false;
    protected shownAt: number = 0;
    protected email: string = "";
    protected password: string = "";

    created() {
      if (!this.token) {
        this.onShow();
      }
      this.$uiBus.on('login.KO', this.onShow);
      this.$uiBus.on('login.OK', this.onHide);
    }
    beforeDestroy() {
      this.$uiBus.off('login.KO', this.onShow);
      this.$uiBus.off('login.OK', this.onHide);
    }
    protected onSubmit() {
      this.$store.dispatch('authModule/login', {email: this.email, password: this.password});
    }
    protected onShow() {
      // debouncing so we don't show a login KO message for each request (which would be normal when loading a page with data)
      const now = new Date().getTime();
      if (this.shownAt && (now - this.shownAt < DEBOUNCE_TIME)) {
        return;
      }
      this.shownAt = now;
      // I have to push it to the nextTick as initially the notification is not yet listening
      Vue.nextTick(() => this.$uiBus.emit('alert', 'Login KO'));
      this.showing = true;
    }
    protected onHide() {
      this.showing = false;
    }
  }

